module.exports = __webpack_public_path__ + "img/target_item_bg.1003689f.png";